import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import TabNavigation from '../../mobile/src/components/TabNavigation';
import Header from '../../mobile/src/components/Header';
import Dashboard from '../../mobile/src/pages/Dashboard';
import Missions from '../../mobile/src/pages/Missions';
import Social from '../../mobile/src/pages/Social';
import Rewards from '../../mobile/src/pages/Rewards';
import Profile from '../../mobile/src/pages/Profile';
import LoadingScreen from '../../mobile/src/components/LoadingScreen';

export type TabType = 'dashboard' | 'missions' | 'social' | 'rewards' | 'profile';

function MobileApp() {
  const [activeTab, setActiveTab] = useState<TabType>('dashboard');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate app initialization
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'missions':
        return <Missions />;
      case 'social':
        return <Social />;
      case 'rewards':
        return <Rewards />;
      case 'profile':
        return <Profile />;
      default:
        return <Dashboard />;
    }
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <div className="mobile-container bg-gray-50">
      {/* Header */}
      <Header activeTab={activeTab} />
      
      {/* Main Content */}
      <main className="flex-1 overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeTab}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
            className="h-full"
          >
            {renderContent()}
          </motion.div>
        </AnimatePresence>
      </main>
      
      {/* Tab Navigation */}
      <TabNavigation activeTab={activeTab} onTabChange={setActiveTab} />
    </div>
  );
}

export default MobileApp;